export const KEY_IDENTIFIER = 'productVariants';

export const DEFAULT_PARAMS = {
  limit: 1000,
  offset: 0,
  sort: 'title',
  descending: false,
};

export const PRODUCT_VARIANTS_KEY = [KEY_IDENTIFIER, DEFAULT_PARAMS];

export const REFRESH_INTERVAL_MS = 1000 * 60 * 10; // 10 min
